const dashboardPT = {
    "view": {
        "label": {
            "allTimeSales": "Vendas de Todos os Tempos",
            "totalToBePaid": "Total a Ser Pago",
            "promoCoins": "Moedas Promocionais",
            "promoDownloadCount": "Contagem de Downloads Promocionais",
            "promoFeedbackCount": "Contagem de Feedbacks Promocionais",
            "totalDownloads": "Total de Downloads",
            "totalFeedbacks": "Total de Feedbacks"
        },
        "options": {
            "earnings": {
                "allTime": "Ganhos de Todos os Tempos",
                "last12Months": "Últimos 12 Meses"
            },
            "months": {
                "jan": "Jan",
                "feb": "Fev",
                "mar": "Mar",
                "apr": "Abr",
                "may": "Mai",
                "jun": "Jun",
                "jul": "Jul",
                "aug": "Ago",
                "sep": "Set",
                "oct": "Out",
                "nov": "Nov",
                "dec": "Dez"
            }
        },
        "message": {
            "userWelcomeTitle": "Olá {{firstName}}, bem-vindo de volta à Plataforma Music Link.",
            "ownedAndManaged": "Sua conta é de propriedade e gerida por <1>{{ parent_company }}</1>, visite nossa <3>Página de Ajuda</3> para saber mais.",
            "completeInformation": "Você ainda não enviou suas informações, por favor <1><strong>Complete Suas Informações</strong></1> para prosseguir!",
            "notSubscribed": "Você não está inscrito em nenhum plano. Inscreva-se agora para desbloquear todo o potencial da plataforma Music Link!",
            "accountBlacklisted": "Sua conta foi bloqueada após a revisão, pois encontramos que as informações associadas com sua conta estão vinculadas a um dos usuários internacionalmente bloqueados em nosso sistema. Como resultado, desativamos a funcionalidade de distribuição para sua conta.",
        }
    }
};

export default dashboardPT;